<template>
  <main class="register">
    <h2>Register</h2>
    <input type="email" placeholder="Username" v-model="email">
    <input type="password" placeholder="Password" v-model="password">
    <button @click="register()">新規登録</button>
    <p>
{{ registerErrorCode }}
{{ registerErrorText }}
    </p>

    <p>You don't have an account? 
      <router-link to="/login">create account now!!</router-link>
    </p>
  </main>
</template>

<script>
import axios from '../axios-auth.js'

export default {
  name: 'Signin',
  data: function () {
    return {
      email: '',
      password: '',
      registerErrorCode:'',
      registerErrorText:'',
    }
  },
  methods: {
    register() {
      axios.post('/accounts:signUp?key=AIzaSyB0tzvdnGh4oeOL7Nwi3bWPllxq5OweoH0', 
        {
          'email':this.email,
          'password':this.password,
          'returnSecureToken':true
        }
      ).then((response) => {
        this.$store.commit('updateIdToken', response.data.idToken)
        this.$router.push('/')
      })
      .catch((error) => {
        this.registerErrorCode = error.response.data.error.code
        this.registerErrorText = error.response.data.error.message
      })
      this.email = ""
      this.password = ""
    }
  }
}
</script>




